<template>
  <div class="layout_outer">
    <header>
      <el-page-header class="flex align_center" @back="$router.go(-1)" :content="title" />
    </header>
    <div class="main">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    backObj () {
      return this.$store.state.outer.backObj
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_outer {
    width: 100%;
    height: 100%;
    & > header {
      display: flex;
      align-items: center;
      height: 70px;
      background-color: #F3F6F9;
      padding-left: 16.93%;
    }
    .main {
      flex: 1;
      // 只有设置了flex 才把其下的content 变成可伸缩的盒子
      display: flex;
      justify-content: center;
      padding: 0 18.75%;
      .content {
        width: 100%;
        padding: 40px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/outer/index.vue